import React, { useEffect, useState, useRef, createRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { createRoot } from "react-dom/client";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  DownloadOutlined,
  EyeOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  Select,
  Tag,
  DatePicker,
} from "antd";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import InvoicePdf from "./InvoicePdf";
import RechargeInvoicePdf from "./RechargeInvoicePdf";
import AdjustmentInvoicePdf from "./AdjustmentInvoicePdf";

const InvoiceListCompany = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const formRef = useRef();
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const CompanyType = authUserData()?.company_type
    ? authUserData()?.company_type
    : "";
  const navigate = useNavigate();
  const { Option } = Select;
  const { Search } = Input;
  const intialFilter = {
    driver_id: "",
    invoice_status: "",
    // company_id: "",
  };

  const [stateFilter, setStateFilter] = useState(intialFilter);
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getInvoiceList = async () => {
      setLoading(true);
      const queryParamsObject = {
        ...state,
        invoice_date: invoiceDate || null,
        due_date: dueDate || null,

        company_id: CompanyId || null,

        invoice_status: stateFilter?.invoice_status || null,

        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();
      try {
        let apiResponse = await getRequest(`invoice/?${queryParams}`);
        if (apiResponse?.data?.results?.success) {
          setInvoiceList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("Error Fetching Invoice List"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getInvoiceList();
  }, [state, reload, t]);
  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    setInvoiceDate(null);
    setDueDate(null);
    form.setFieldsValue({ search: "" });

    formRef.current.setFieldsValue({
      invoice_date: undefined,
      due_date: undefined,
      invoice_status: undefined,
    });
  };
  const handlePaymentStatus = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      invoice_status: value,
    }));
  };
  const handleInvoiceDate = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setInvoiceDate(formattedDate);
  };
  const handleDueDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setDueDate(formattedDate);
  };
  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  const handleDownload = async (invoiceId, company_type) => {
    try {
      let apiResponse = await getRequest(`invoice/${invoiceId}`);
      console.log("apiResponse", apiResponse);

      const data = apiResponse.data.data;
      const {
        company_type,
        recharge_amount,
        total_amount_with_gst,
        adjustment_amount,
      } = data;
      const tempContainer = document.createElement("div");
      document.body.appendChild(tempContainer);

      const invoiceRef = createRef();

      const root = createRoot(tempContainer);
      console.log("company_type", company_type);
      if (
        company_type === "Pre Paid" &&
        recharge_amount &&
        parseFloat(recharge_amount) > 0
      ) {
        root.render(<RechargeInvoicePdf ref={invoiceRef} data={data} />);
      } else if (
        company_type === "Post Paid" &&
        total_amount_with_gst &&
        parseFloat(total_amount_with_gst) > 0
      ) {
        root.render(<InvoicePdf ref={invoiceRef} data={data} />);
      } else if (adjustment_amount && parseFloat(adjustment_amount) > 0) {
        root.render(<AdjustmentInvoicePdf ref={invoiceRef} data={data} />);
      } else {
        // Fallback for no valid amount found
        console.warn("No valid amount found to generate invoice PDF.");
      }

      // Wait for the component to render
      setTimeout(async () => {
        const canvas = await html2canvas(invoiceRef.current);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`invoice_${data.invoice_number}.pdf`);

        root.unmount();
        document.body.removeChild(tempContainer);
      }, 1000); // small delay to ensure DOM render
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "invoice_to_name" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_to_name";
    }
    if (sortField === "invoice_to_name" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_to_name";
    }

    if (sortField === "billing_type" && sortOrder === "ascend") {
      sortingEnumKey = "billing_type";
    }
    if (sortField === "billing_type" && sortOrder === "descend") {
      sortingEnumKey = "-billing_type";
    }

    if (sortField === "invoice_number" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_number";
    }
    if (sortField === "invoice_number" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_number";
    }
    if (sortField === "remaining_days" && sortOrder === "ascend") {
      sortingEnumKey = "remaining_days";
    }
    if (sortField === "remaining_days" && sortOrder === "descend") {
      sortingEnumKey = "-remaining_days";
    }
    if (sortField === "transaction_type" && sortOrder === "ascend") {
      sortingEnumKey = "transaction_type";
    }
    if (sortField === "transaction_type" && sortOrder === "descend") {
      sortingEnumKey = "-transaction_type";
    }

    if (sortField === "invoice_date" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_date";
    }
    if (sortField === "invoice_date" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_date";
    }

    if (sortField === "amount" && sortOrder === "ascend") {
      sortingEnumKey = "amount";
    }
    if (sortField === "amount" && sortOrder === "descend") {
      sortingEnumKey = "-amount";
    }

    if (sortField === "due_date" && sortOrder === "ascend") {
      sortingEnumKey = "due_date";
    }
    if (sortField === "due_date" && sortOrder === "descend") {
      sortingEnumKey = "-due_date";
    }

    if (sortField === "invoice_status" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_status";
    }
    if (sortField === "invoice_status" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_status";
    }

    return sortingEnumKey;
  };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_company_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/my-invoice"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await postRequest(`invoice/${id}/update-invoice-status/`)
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload((reload) => !reload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [checkedList, setCheckedList] = useState([
    "invoice_to_name",
    "billing_type",
    "remaining_days",
    "invoice_number",
    "invoice_date",
    "amount",
    "due_date",
    "transaction_type",
    "invoice_status",
    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Company Name",
      dataIndex: "invoice_to_name",
      key: "invoice_to_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    // {
    //   title: "Billing Type",
    //   dataIndex: "billing_type",
    //   key: "billing_type",
    //   sorter: true,
    //   width: 200,
    //   render: (dataIndex) => (
    //     <div
    //       style={{
    //         maxWidth: "400px",
    //         whiteSpace: "nowrap",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         textTransform: "none",
    //       }}
    //     >
    //       {dataIndex}
    //     </div>
    //   ),
    // },
    {
      title: "Invoice No.",
      dataIndex: "invoice_number",
      key: "invoice_number",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      width: 180,
      sorter: true,
      render: (date) => date,
    },
    {
      title: "Type",
      dataIndex: "transaction_type",
      key: "transaction_type",
      width: 180,
      sorter: true,
      render: (_, record) => {
        switch (record?.transaction_type) {
          case "recharge_initiated":
            return "Recharge Initiated";
          case "payment_initiated":
            return "Payment Initiated";
          default:
            return record?.transaction_type;
        }
      },
    },
    {
      title: "Amount",
      key: "amount",
      sorter: true,
      width: 130,
      render: (_, record) => {
        const { total_amount_with_gst, adjustment_amount, recharge_amount } =
          record;

        // Function to return the first non-zero, non-null amount
        const getValidAmount = () => {
          if (total_amount_with_gst && total_amount_with_gst !== "0.00")
            return `$${total_amount_with_gst}`;
          if (adjustment_amount && adjustment_amount !== "0.00")
            return `$${adjustment_amount}`;
          if (recharge_amount && recharge_amount !== "0.00")
            return `$${recharge_amount}`;
          return "-"; // fallback if all values are null/0
        };

        return (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {getValidAmount()}
          </div>
        );
      },
    },
    // Add this column only if companyType is not "Pre Paid"
    ...(CompanyType !== "Pre Paid"
      ? [
          {
            title: "Due Date",
            dataIndex: "due_date",
            key: "due_date",
            sorter: true,
            width: 130,
            render: (_, record) => (record?.due_date ? record?.due_date : "-"),
          },
        ]
      : []),
    ...(CompanyType !== "Pre Paid"
      ? [
          {
            title: "Remaining Days",
            dataIndex: "remaining_days",
            key: "remaining_days",
            sorter: true,
            width: 130,
            render: (_, record) =>
              record?.company_type === "Post Paid" &&
              record?.transaction_type === "payment_initiated"
                ? record?.remaining_days
                : "-",
          },
        ]
      : []),
    {
      title: "Status",
      dataIndex: "invoice_status",
      key: "invoice_status",
      fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            // value={e ? e : record.status}
            //onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
            value={e ? e : record.invoice_status}
            onChange={(e) => handleStatus(record.id, e)}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Paid" disabled>
              {" "}
              <div className="dealdoneopt">{t("Paid")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="View Invoice">
            <span
              //   onClick={() =>
              //     handleDownload(
              //       record.id,
              //       record.company_id,
              //       record?.company_type
              //     )
              //   }
              style={{ cursor: "pointer" }}
            >
              <EyeOutlined />
            </span>
          </Tooltip> */}
          <Tooltip title="Download Invoice">
            <span
              className="material-symbols-outlined"
              onClick={() =>
                handleDownload(
                  record.id,

                  record?.company_type
                )
              }
              style={{ cursor: "pointer" }}
            >
              download
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  // const columnMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           <Col span={12}>
  //             <Checkbox value="invoice_to_name">Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_email">E-mail</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_street_address">Address</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_number">Contact Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_contact_name">Contact Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_abn_no">ABN Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_note">Note</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="status">Status</Checkbox>
  //           </Col>

  //           <Col span={12}>
  //             <Checkbox value="operation" disabled>
  //               Action
  //             </Checkbox>
  //           </Col>
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );

  const allColumns = [
    { key: "invoice_to_name", title: "Company Name" },
    { key: "billing_type", title: "Billing Type" },
    { key: "remaining_days", title: "Remaining Days" },
    { key: "invoice_number", title: "Invoice No." },
    { key: "invoice_date", title: "Invoice Date" },
    { key: "transaction_type", title: "Type" },
    { key: "amount", title: "Amount" },
    { key: "due_date", title: "Due Date" },
    { key: "invoice_status", title: "Status" },
    { key: "operation", title: "Actions" },
  ];

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("company/archive-company/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("company_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};
  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `invoice/login-company-invoice-excel-download/`;
    const fileType = "csv";

    // Construct query parameters similar to getEmployeeList
    const queryParamsObject = {
      // ...state,
      invoice_date: invoiceDate || null,
      due_date: dueDate || null,
      // company_id: stateFilter?.company_id || null,
      // company_type: stateFilter?.company_type || null,
      invoice_status: stateFilter?.invoice_status || null,
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    try {
      // Use getRequest with the constructed query parameters
      const response = await getRequest(`${endpoint}?${queryParams}`);

      // Process the response to download the CSV file
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `CompanyReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>{t("Manage Invoices")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Manage Invoices")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}

            {/* </Tooltip> */}

            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="invoice_date"
                      label={t("invoice_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_invoice_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleInvoiceDate}
                        style={{ width: "140px" }}
                        placeholder={t("pl_invoice_date")}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="due_date"
                      label={t("due_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_due_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleDueDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("pl_due_date")}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="invoice_status"
                      label={t("Status")}
                      value={state?.invoice_status}
                    >
                      <Select
                        showArrow
                        placeholder={t("Select Status")}
                        onChange={(value) => handlePaymentStatus(value)}
                      >
                        <Option key="Pending" value="Pending">
                          Pending
                        </Option>
                        <Option key="Paid" value="Paid">
                          Paid
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {invoiceDate ||
                  dueDate ||
                  stateFilter?.invoice_status ||
                  stateFilter?.company_id ||
                  stateFilter?.company_type ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
          <Table
            // rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={invoiceList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default InvoiceListCompany;
